/**
 * Labstep
 *
 * @module grid/BatchCreateResourceItems/components/AddRow
 * @desc Add a row in DataGrid
 */

import { fieldQuantity } from 'labstep-web/components/ResourceItem/Action/BulkCreate/Modal';
import { useGridBatchCreateResourceItemsServiceFromContext } from 'labstep-web/contexts/grid/hook';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { FormReusable as ReusableForm } from 'labstep-web/core/Form/Reusable';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type { GridBatchCreateResourceItemsAddRowProps } from 'labstep-web/grid/BatchCreateResourceItems/components/AddRow/types';
import { useBatchCreateItemContext } from 'labstep-web/grid/BatchCreateResourceItems/context';
import type React from 'react';

export const GridBatchCreateResourceItemsAddRow: React.FC<
  GridBatchCreateResourceItemsAddRowProps
> = ({ resource }) => {
  const context = useBatchCreateItemContext();
  const gridBatchCreateResourceItemsService =
    useGridBatchCreateResourceItemsServiceFromContext();

  if (!context || !gridBatchCreateResourceItemsService) {
    return <div></div>;
  }

  const { data, setData, dateFormats } = context;

  return (
    <Modal
      size="small"
      header={'Add rows'}
      viewComponent={
        <ActionComponent type="text" icon="plus" text="Add row" />
      }
      content={({ toggleModal }): React.ReactElement => (
        <ReusableForm
          autoFocus
          defaultValues={{ quantity: 1 }}
          fields={[fieldQuantity]}
          onSubmit={(values) => {
            gridBatchCreateResourceItemsService.addRows(
              data,
              setData,
              resource,
              dateFormats,
              values.quantity as number,
            );
            toggleModal();
          }}
        />
      )}
    />
  );
};
